// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__LzHrJ","leaf":"Loader_leaf__1puT3"};